/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { fonts, mixins, colors as CCColors } from '@blend/consumer-components';
import { useConsumerTheme } from '../../../hooks/useConsumerTheme';
import useParticipantNetworkQualityLevel from '../../../hooks/videoProvider/useParticipantNetworkQualityLevel';
import { mediaBreakpoints } from '../../../common/responsive';

export namespace ParticipantIdentity {
  export interface Props {
    identity: string;
    isDominantSpeaker?: boolean;
    participant: VideoProvider.IParticipant;
  }
}

export const ParticipantIdentity: React.FC<ParticipantIdentity.Props> = ({
  identity,
  isDominantSpeaker,
  participant,
}) => {
  const {
    appConfig: { colors },
  } = useConsumerTheme();
  const networkQualityLevel = useParticipantNetworkQualityLevel(participant);
  const styles = StyleSheet.create({
    wrapper: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      fontSize: 12,
      color: 'white',
      backgroundColor: isDominantSpeaker ? colors.action : mixins.fade(CCColors.black, 0.7),
      ...mixins.padding(4),
      ...mixins.borderRadius(2),
      ...fonts.UntitledSans,
      [mediaBreakpoints.mobile]: {
        fontSize: 9,
      },
    },
  });

  return (
    <>
      <div data-it="ParticipantIdentity" className={css(styles.wrapper)}>
        {identity}
        {networkQualityLevel !== null && networkQualityLevel < 3 && (
          <div
            style={{
              color: networkQualityLevel !== null && networkQualityLevel >= 2 ? 'yellow' : 'red',
            }}
          >
            {'poor network connection'}
          </div>
        )}
      </div>
    </>
  );
};
